import axios from "axios";
import router from "./../router";
import store from "./../vuex";
import * as types from "./../vuex/modules/app/mutation-type.js";
import NProgress from "nprogress";
import { buildEncryptedRequest, decryptResponse } from './crypto.js';

// axios 配置
axios.defaults.timeout = 120000;
axios.defaults.baseURL = process.env.VUE_APP_API_ROOT;
axios.defaults.headers.post["Content-Type"] = "application/json";

if (!sessionStorage.getItem("API_DEBUG")) {
  sessionStorage.setItem("API_DEBUG","0")
}

// http request 拦截器
axios.interceptors.request.use(
  config => {
    if (sessionStorage.token) {
      config.headers.token = `${sessionStorage.token}`;
    } else if (sessionStorage.mkYHTToken) {
      config.headers.token = `${sessionStorage.mkYHTToken}`;
    }
    const language = sessionStorage.getItem('X-Language') || 'zh-CN';
    config.headers['X-Language'] = language;
    
    // 浏览器sessionStorage.API_DEBUG = '1' //进行明文调试
    let isNeedEncrypt = process.env.VUE_APP_IS_BUILD === "1" ? sessionStorage.getItem("API_DEBUG") ?? "0" : "1";
    // isNeedEncrypt = '0'; // 调试加密。
    config.headers['X-Debug-Mode'] = isNeedEncrypt;
    if (isNeedEncrypt === "0" && config.url !== process.env.VUE_APP_API_ROOT + 'y/generatecode') {
      try {
        // 构建加密请求（提取需要加密的URL字段：config.encryptUrlFields）
        const { requestConfig, aesKeyEncrypted, aesKey, iv } = buildEncryptedRequest({
          url: config.url,
          method: config.method,
          data: config.data,
          encryptUrlFields: config.encryptUrlFields || [] // 新增：需要加密的URL字段列表
        });

        // 更新请求配置
        config.url = requestConfig.url;
        config.data = requestConfig.data;

        // 设置Header（AES Key/IV）
        config.headers['X-AES-Key'] = aesKeyEncrypted;
        config.headers['X-AES-IV'] = iv;

        // 暂存AES Key用于响应解密
        config.meta = { ...config.meta, aesKey };
      } catch (error) {
        console.error('请求加密失败：', error);
        throw new Error(`请求加密失败，请检查：${error.message}`);
      }
    }
    NProgress.start();
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);

// http response 拦截器
axios.interceptors.response.use(
  response => {
    NProgress.done();
    // return response;
    const { config, data } = response;
    // 浏览器sessionStorage.API_DEBUG = '1' //进行明文调试
    let isNeedEncrypt = process.env.VUE_APP_IS_BUILD === "1" ? sessionStorage.getItem("API_DEBUG") ?? "0" : "1";
    // isNeedEncrypt = '0'; // 调试加密。
    config.headers['X-Debug-Mode'] = isNeedEncrypt;
    if (isNeedEncrypt === "0" && config.url !== process.env.VUE_APP_API_ROOT + 'y/generatecode') {
      try {
        const aesKey = config.meta?.aesKey;
        if (!aesKey) return data;
        const decryptedData = decryptResponse(data, aesKey);
        response.data = decryptedData;
        return response
      } catch (error) {
        console.error('响应解密失败：', error);
        throw new Error(`响应解密失败：${error.message}`);
      } 
    }else{
      return response;
    }
    
  },
  error => {
    NProgress.done();
    if (error.response?.config?.meta?.aesKey) {
      try {
        const decryptedError = decryptResponse(
          error.response.data,
          error.response.config.meta.aesKey
        );
        error.decryptedData = decryptedError;
      } catch (e) {
        console.error('错误响应解密失败：', e);
      }
    }
    
    if (error.status) {
      switch (error.status) {
        case 401:
          // 401 清除token信息并跳转到登录页面
          store.commit(types.LOGOUT);
          router.replace({
            path: "login",
            query: {
              redirect: router.currentRoute.fullPath
            }
          });
          break;
      }
    }
    return Promise.reject(error);

  }
);

let http = {
  get: function(url, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(url, {
          params
        })
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  post: function(url, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(url, data)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  put: function (url, data) {
    return new Promise((resolve, reject) => {
      axios.put(url, data)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          // reject(error) 
        })
    })
  },
  delete: function (url, params) {
    return new Promise((resolve, reject) => {
      axios.delete(url, {
        params
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          // reject(error)
        })
    })
  }
};

http.axios = axios;

export default http;
